/**
 * Constants for contact-related functionality
 */
export const CONTACT_CONSTANTS = {
  SEARCH: {
    MIN_LENGTH: 2,
    MAX_SUGGESTIONS: 20,
  },
  FORM: {
    SELECTION_DELAY_MS: 100,
    INITIAL_VALUES: {
      name: "",
      title: "",
      email: "",
      phoneNumber: "",
    },
  },
  VALIDATION: {
    REQUIRED_FIELDS: ["name", "email"] as const,
  },
} satisfies Record<string, unknown>;

/**
 * Constants for cover section functionality
 */
export const COVER_CONSTANTS = {
  CURRENT_YEAR: new Date().getFullYear(),
} satisfies Record<string, unknown>;
